document.addEventListener('click', (event) => {
  const button = event.target.closest('button');
  if (!button?.closest('[data-otf-cart-recommendation]') || !button.closest('modal-opener')) return;
  document.querySelector('cart-popup')?.close();
}, true);

class CartPopup extends HTMLElement {
  constructor() {
    super();

    this.onPopupKeyup = (event) => {
      if (event.code !== 'Escape') return;
      event.preventDefault();
      event.stopPropagation();
      this.close();
    };
    this.setHeaderCartIconAccessibility();
  }

  connectedCallback() {
    this.popupWrapper = this.closest('[data-popup-type="cart-popup"]');
    if (!this.popupWrapper) return;
    this.popupWasOpen = false;
    this.onPopupFocus = () => { this.focusTrapHandler = trapFocusHandlers.focusin; };
    this.onPopupTransitionEnd = (event) => {
      if (event.target === this.popupWrapper && !this.popupWrapper.contains(document.activeElement)) this.focusContents();
    };
    this.popupWrapper.addEventListener('keyup', this.onPopupKeyup);
    this.popupWrapper.addEventListener('focusin', this.onPopupFocus);
    this.popupWrapper.addEventListener('transitionend', this.onPopupTransitionEnd);
    this.popupObserver = new MutationObserver(() => this.syncPopupVisibility());
    this.popupObserver.observe(this.popupWrapper, { attributes: true, attributeFilter: ['class'] });
    this.syncPopupVisibility();
  }

  disconnectedCallback() {
    this.popupObserver?.disconnect();
    this.releaseFocus(false);
    this.popupWrapper?.removeEventListener('keyup', this.onPopupKeyup);
    this.popupWrapper?.removeEventListener('focusin', this.onPopupFocus);
    this.popupWrapper?.removeEventListener('transitionend', this.onPopupTransitionEnd);
  }

  syncPopupVisibility() {
    const isOpen = !this.popupWrapper.classList.contains('hide-popup');
    this.popupWrapper.inert = !isOpen;
    this.popupWrapper.setAttribute('aria-hidden', String(!isOpen));
    if (isOpen === this.popupWasOpen) return;
    this.popupWasOpen = isOpen;
    if (isOpen) {
      const active = document.activeElement;
      if (active && active !== document.body && !this.popupWrapper.contains(active)) this.activeElement = active;
      requestAnimationFrame(() => requestAnimationFrame(() => {
        if (this.isConnected) this.focusContents();
      }));
    } else {
      this.releaseFocus(!document.body.hasAttribute('active-popup'));
    }
  }

  focusContents(element) {
    if (!this.popupWrapper || this.popupWrapper.classList.contains('hide-popup')) return;
    const target = element || this.popupWrapper.querySelector('.theme-popup-close') || this.querySelector('.popup__inner');
    if (!target) return;
    trapFocus(this.popupWrapper, target);
    this.focusTrapHandler = trapFocusHandlers.focusin;
  }

  releaseFocus(restore) {
    if (this.focusTrapHandler && this.focusTrapHandler === trapFocusHandlers.focusin) removeTrapFocus();
    this.focusTrapHandler = null;
    const opener = this.activeElement;
    this.activeElement = null;
    if (restore && opener?.isConnected && !this.popupWrapper?.contains(opener)) opener.focus();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    const cartLinkSticky = document.querySelector('#cart-icon-sticky-bubble');
    const cartLinkMobile = document.querySelector('#fixed-cart-icon-bubble');
    if(cartLink){
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink)
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    }
    if(cartLinkSticky){
      cartLinkSticky.setAttribute('role', 'button');
      cartLinkSticky.setAttribute('aria-haspopup', 'dialog');
      cartLinkSticky.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLinkSticky)
      });
      cartLinkSticky.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLinkSticky);
        }
      });
    }
    if(cartLinkMobile){
      cartLinkMobile.setAttribute('role', 'button');
      cartLinkMobile.setAttribute('aria-haspopup', 'dialog');
      cartLinkMobile.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLinkMobile)
      });
      cartLinkMobile.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLinkMobile);
        }
      });
    }
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartPopupNote = this.querySelector('[id^="Details-"] summary');
    if (cartPopupNote && !cartPopupNote.hasAttribute('role')) this.setSummaryAccessibility(cartPopupNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      if($(document).find('[data-popup-type="cart-popup"]').hasClass('hide-popup')){
        $(document).find('[data-popup-type]').addClass('hide-popup');
        $(document).find('[data-popup-type="cart-popup"]').removeClass('hide-popup');
        $(document).find('.theme-popup-overlay,theme-menu-popup-overlay').removeClass('hidden-overlay');
        $(document).find('body').attr('active-popup','cart');
      }else{
        $(document).find('[data-popup-type="cart-popup"]').addClass('hide-popup');
        $(document).find('.theme-popup-overlay,.theme-menu-popup-overlay').addClass('hidden-overlay');
        $(document).find('body').removeAttr('active-popup');
      }
      if($(document).find('[data-popup-type="cart-popup"]').length){
        setTimeout(function(){
          $(document).find('.cart--popup-recommandation').addClass('recommandation-active');
        },450);
      }
    });

  }

  close() {
    this.classList.remove('active');
    this.closest('[data-popup-type="cart-popup"]')?.classList.add('hide-popup');
    document.body.removeAttribute('active-popup');
    document.querySelectorAll('.theme-popup-overlay, .theme-menu-popup-overlay').forEach((overlay) => overlay.classList.add('hidden-overlay'));
    document.querySelector('.cart--popup-recommandation')?.classList.remove('recommandation-active');
    document.querySelectorAll('.cart--popup-quick-add').forEach((quickAdd) => quickAdd.classList.remove('active'));
    this.releaseFocus(true);
  }

  setSummaryAccessibility(cartPopupNote) {
    cartPopupNote.setAttribute('role', 'button');
    cartPopupNote.setAttribute('aria-expanded', 'false');

    if(cartPopupNote.nextElementSibling.getAttribute('id')) {
      cartPopupNote.setAttribute('aria-controls', cartPopupNote.nextElementSibling.id);
    }

    cartPopupNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartPopupNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  removeQuickShopCards(contents) {
    if (!contents) return;
    const ownedIds = new Set(Array.from(contents.querySelectorAll('modal-opener[data-modal]'), (opener) => opener.getAttribute('data-modal').slice(1)));
    document.querySelectorAll('quick-add-modal[data-otf-cart-owner="cart-popup"]').forEach((modal) => {
      if (!ownedIds.has(modal.id)) return;
      if (!modal.classList.contains('hide-popup')) modal.hide?.();
      else modal.cancelRequests?.();
      modal.remove();
    });
  }

  renderContents(parsedState) {
    this.removeQuickShopCards(this.querySelector('#CartPopup'));
    this.querySelector('.popup__inner').classList.contains('is-empty') && this.querySelector('.popup__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      if(section.id == 'cart-icon-bubble'){
        const mobileBubble = document.querySelector('#mobile-cart-icon-bubble');
        const stickyBubble = document.querySelector('#cart-icon-sticky-bubble');

        if(mobileBubble){
          mobileBubble.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        }
        if(stickyBubble){
          stickyBubble.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
        }
      }
    }));
    CartItems.syncCheckoutProtection();
  }

  renderCartSection(html) {
    const source = html.querySelector('cart-popup');
    const sourceContents = html.getElementById('CartPopup');
    const contents = this.querySelector('#CartPopup');
    if (!source || !sourceContents || !contents) throw new Error('Cart popup markup is missing.');
    const active = document.activeElement;
    const restoreFocus = this.contains(active);
    const focusId = restoreFocus ? active.id : null;
    this.removeQuickShopCards(contents);
    contents.innerHTML = sourceContents.innerHTML;
    this.classList.toggle('is-empty', source.classList.contains('is-empty'));
    CartItems.syncCheckoutProtection();
    if (restoreFocus) {
      const replacement = focusId ? document.getElementById(focusId) : null;
      this.focusContents(replacement && this.contains(replacement) ? replacement : null);
    }
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-popup',
        selector: '#CartPopup'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-popup', CartPopup);

class CartPopupItems extends CartItems {
  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      // These theme publishers already render the popup from the cart response.
      if ((event.source === 'cart-items' && event.cartComponent === this) || event.source === 'product-form' || event.source === 'card-size-picker' || event.source === 'cart-popup-add') return;
      this.onCartUpdate();
    });
  }
 
  onCartUpdate() {
    return CartItems.reconcileCart(null, false);
  }

  getSectionsToRender() {
    return [
      {
        id: 'CartPopup',
        section: 'cart-popup',
        selector: '.popup__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-popup-items', CartPopupItems);


async function addCartPopupRecommendation(button, variantId, quantity = 1) {
  if (CartItems.recoveryRelease || button.disabled || button.classList.contains('btn--loading') || !variantId) return;
  const form = button.closest('.quick--add-form');
  const variantInput = form?.querySelector('input[name="id"]');
  if (variantInput?.disabled) return;
  const source = variantInput || button;
  if (source.dataset.requiresSellingPlan === 'true') {
    window.location.assign(source.dataset.productUrl);
    return;
  }
  const cart = document.querySelector('cart-popup');
  const errorElement = (form || button.closest('.cart-item'))?.querySelector('.theme--error-message');
  errorElement?.classList.add('hide');
  button.classList.add('btn--loading');
  const finishMutation = CartItems.beginMutation();
  let rejectionMessage;
  try {
    const responseText = await CartItems.fetchCartText(routes.cart_add_url, {
      ...fetchConfig(),
      body: JSON.stringify({ id: variantId, quantity: Number(quantity) || 1, sections: cart.getSectionsToRender().map(section => section.id), sections_url: window.location.pathname })
    }, new AbortController(), true);
    const result = JSON.parse(responseText);
    if (result.status || result.errors) {
      rejectionMessage = result.description || window.cartStrings.error;
      throw new Error(rejectionMessage);
    }
    if (CartItems.canRenderSnapshot()) {
      cart.renderContents(result);
      cart.classList.remove('is-empty');
      cart.focusContents();
    }
    publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-popup-add', productVariantId: variantId });
  } catch (error) {
    if (await finishMutation(true)) CartItems.showCartMessage(rejectionMessage || window.cartStrings.error);
  } finally {
    finishMutation();
    button.classList.remove('btn--loading');
    document.querySelectorAll('.cart--popup-recommandation .cart-popup-items').forEach(items => items.classList.remove('overlay'));
  }
}

function showCartPopupSelectionRecovery(form, productUrl) {
  const input = form.querySelector('input[name="id"]');
  const button = form.querySelector('.quick--add-to-cart[name="add"]');
  if (input) input.disabled = true;
  if (button) button.disabled = true;
  const error = form.querySelector('legend.theme--error-message');
  if (!error) return;
  const message = document.createElement('span');
  message.textContent = window.cartStrings.selectionRecovery;
  const link = document.createElement('a');
  link.href = productUrl;
  link.className = 'btn btn--secondary otf-selection-retry';
  link.textContent = window.cartStrings.selectionOpenProduct;
  error.replaceChildren(message, link);
  error.classList.remove('hide');
}

$(document).on('click', '.quick--add.popup--close', function() {
  $(document).find('.cart--popup-recommandation .cart-popup-items').removeClass('overlay');
  $(document).find('.cart--popup-quick-add').removeClass('active');
});
$(document).on('click', 'button[data-quick-add]', function(event) {
  event.preventDefault();
  if (this.dataset.requiresSellingPlan === 'true') {
    window.location.assign(this.dataset.productUrl);
    return;
  }
  if (this.dataset.quickAdd === 'true') {
    $(document).find('legend.theme--error-message').addClass('hide');
    $(document).find('.cart--popup-recommandation .cart-popup-items').addClass('overlay');
    const handle = this.dataset.productHandle;
    document.querySelectorAll('.cart--popup-quick-add').forEach(panel => {
      if (panel.dataset.productHandle === handle) panel.classList.add('active');
    });
  } else {
    addCartPopupRecommendation(this, this.dataset.variantId, this.dataset.quantity);
  }
});
if ($(document).find('[data-popup-type="cart-popup"]').length) {
  $(document).on('click', '.quick--add-to-cart', function(event) {
    event.preventDefault();
    event.stopPropagation();
    const form = this.closest('.quick--add-form');
    addCartPopupRecommendation(this, form?.querySelector('input[name="id"]')?.value, form?.querySelector('input[name="quantity"]')?.value);
  });
  $(document).on('change','.cart-option-select',function(event){
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    let parentDiv = $(this).parents('.cart--popup-quick-add');
    let formDiv = $(this).closest('.quick--add-form');
    let variantContainer = formDiv.find('.variant--selection-options');
    let currentProductUrl = variantContainer.attr('data-url');
    let sectionId = variantContainer.attr('data-section');

    let addButton = formDiv.find('.quick--add-to-cart[name="add"]');
    addButton.prop('disabled', true);

    let selectedValueIds = [];
    const selectedValues = new Map();
    let newProductUrl = $(this).find('option:selected').attr('data-product-url') || null;

    formDiv.find('.cart-option-select').each(function(){
      selectedValues.set(this.dataset.index, this.value);
      let selectedOption = $(this).find('option:selected');
      let optionValueId = selectedOption.attr('data-option-value-id');

      if (optionValueId) {
        selectedValueIds.push(optionValueId);
      }


    });

    let productUrl = newProductUrl || currentProductUrl;
    let shouldSwapProduct = currentProductUrl !== productUrl;

    let params = new URLSearchParams({
      section_id: sectionId,
      option_values: selectedValueIds.join(',')
    });

    const formElement = formDiv[0];
    formElement.otfVariantController?.abort();
    const controller = new AbortController();
    formElement.otfVariantController = controller;
    formDiv.find('input[name="id"]').prop('disabled', true);
    formDiv.find('legend.theme--error-message').addClass('hide');
    CartItems.fetchCartText(`${productUrl}?${params.toString()}`, {}, controller)
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        if (controller !== formElement.otfVariantController || !formElement.isConnected) return;
        const sourceVariantContainer = html.querySelector('.variant--selection-options');

        if (!sourceVariantContainer || !html.querySelector('input[name="id"]')) {
          throw new Error('Variant container not found in response');
        }

        if (shouldSwapProduct) {
          variantContainer.attr('data-url', productUrl);
        }

        updateCartPopupOptions(formDiv, sourceVariantContainer, selectedValues);
        const sourceTitle = html.querySelector('.product--title');
        if (sourceTitle) {
          parentDiv.find('.product--title').text(sourceTitle.textContent).attr('href', sourceTitle.getAttribute('href'));
        }
        updateCartPopupPrice(parentDiv, html);
        updateCartPopupImage(parentDiv, html);
        updateCartPopupVariantInput(formDiv, html, selectedValues);
        updateCartPopupButton(formDiv, html);
      })
      .catch((error) => {
        if (controller !== formElement.otfVariantController || !formElement.isConnected) return;
        showCartPopupSelectionRecovery(formElement, productUrl);
      });
  });

  function updateCartPopupOptions(form, sourceContainer, selectedValues) {
    const container = form.find('.variant--selection-options');
    container.html(sourceContainer.innerHTML);
    container.find('select').removeClass('js-option-select').addClass('cart-option-select');
    form.find('.cart-option-select').each(function() {
      const requested = selectedValues.get(this.dataset.index);
      this.value = Array.from(this.options).some(option => option.value === requested) ? requested : '';
    });
    form.find('legend.theme--error-message').addClass('hide');
  }

  function updateCartPopupPrice(parentDiv, html) {
    let sourcePrice = html.querySelector('.price');
    let currentPrice = parentDiv.find('.price');

    if (sourcePrice && currentPrice.length) {
      currentPrice.html(sourcePrice.innerHTML);
    }
  }

  function updateCartPopupImage(parentDiv, html) {
    let sourceImage = html.querySelector('.quickBuy--product-image');
    let currentImage = parentDiv.find('.cart--product-image');

    if (sourceImage && currentImage.length) {
      currentImage.attr('src', sourceImage.src);
      currentImage.attr('alt', sourceImage.alt);
    } else {
      if (!sourceImage) console.warn('Source image not found (looking for .quickBuy--product-image)');
      if (!currentImage.length) console.warn('Current image not found in cart popup');
    }
  }

  function updateCartPopupButton(form, html) {
    const input = form[0].querySelector('input[name="id"]');
    const button = form.find('.quick--add-to-cart[name="add"]');
    if (!button.length || !input) return;
    const needsSize = Array.from(form[0].querySelectorAll('[data-otf-size]')).some(select => !select.value);
    button.prop('disabled', input.disabled);
    const label = needsSize ? form[0].dataset.otfChooseSize : input.disabled ? window.variantStrings.unavailable : window.variantStrings.addToCart;
    button.find('span').first().text(label);
  }

  function updateCartPopupVariantInput(form, html, selectedValues) {
    const sourceInput = html.querySelector('input[name="id"]');
    const currentInput = form.find('input[name="id"]');
    if (!sourceInput || !currentInput.length) throw new Error('Variant input is missing.');
    const options = JSON.parse(sourceInput.dataset.otfVariantOptions || '[]');
    const selects = Array.from(form[0].querySelectorAll('.cart-option-select'));
    const retained = selectedValues.size === selects.length && selects.every(select => selectedValues.get(select.dataset.index) === select.value);
    const matches = retained && Array.isArray(options) && options.length === selects.length && options.every((value, index) => value === selects[index].value);
    const variantId = sourceInput.dataset.otfVariantId || '';
    const needsSize = selects.some(select => select.hasAttribute('data-otf-size') && !select.value);
    currentInput.val(matches && !needsSize ? variantId : '');
    currentInput.prop('disabled', !matches || needsSize || !variantId || sourceInput.dataset.otfAvailable !== 'true');
    currentInput.attr('data-requires-selling-plan', sourceInput.dataset.requiresSellingPlan || 'false');
    currentInput.attr('data-product-url', sourceInput.dataset.productUrl || '');
    const quantity = html.querySelector('input[name="quantity"]');
    if (quantity) form.find('input[name="quantity"]').val(quantity.value);
  }
}

